// GENERATED by scripts/build-icons.mjs from icons/globe.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Globe = createIcon('globe', [
  ['circle', { cx: "12", cy: "12", r: "10" }],
  ['path', { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" }],
  ['path', { d: "M2 12h20" }],
])
